export default __webpack_public_path__ + "static/pic4-7361a9120b9b6a075c2a2f24697c2656.png";